/**
 * i18n constants - safe to import in server components (no React context)
 */

export const LANG_STORAGE_KEY = "big-sport-lang";
export const LANG_COOKIE_NAME = "big-sport-lang";
